export default __webpack_public_path__ + "static/media/photo-agri.3fddcffe.avif";